import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import IncomeCard from "components/Cards/IncomeCard";
import OrdersCard from "components/Cards/OrdersCard";
import DiscountCard from "components/Cards/DiscountCard";
import PayedCard from "components/Cards/PayedCard";
import OpenCard from "components/Cards/OpenCard";
import CancelledCard from "components/Cards/CancelledCard";
import PeopleCard from "components/Cards/PeopleCard";
import SalesByPaymentMethod from "components/Charts/SalesByPaymentMethod";
import SalesByUser from "components/Charts/SalesByUser";
import DestroyedCard from "components/Cards/DestroyedCard";
import SalesPerMode from "components/Charts/SalesPerMode";
import DocumentCard from "components/Cards/DocumentCard";

function HipposDashboard() {
  return (
    <>
      <Container fluid>
        <Row>
          <Col lg="4" xs="12" sm="12">
            <IncomeCard />
          </Col>
          <Col lg="4" xs="12" sm="12">
            <DocumentCard />
          </Col>
          <Col lg="4" sm="12" xs="12">
            <OrdersCard />
          </Col>
          <Col lg="4" sm="12">
            <PayedCard />
          </Col>
          <Col lg="4" sm="12">
            <OpenCard />
          </Col>
          <Col lg="4" sm="12">
            <PeopleCard />
          </Col>
          <Col lg="4" sm="12">
            <DiscountCard />
          </Col>
          <Col lg="4" sm="12">
            <CancelledCard />
          </Col>
          <Col lg="4" sm="12">
            <DestroyedCard />
          </Col>
        </Row>
        <Row>
          <Col md="6" sm="12">
            <SalesByPaymentMethod />
          </Col>
          <Col md="6" sm="12">
            <SalesByUser />
          </Col>
        </Row>
        <Row>
          <Col md="6" sm="12">
            <SalesPerMode />
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default HipposDashboard;
